enum FilterType {
  Button = 'button',
  ButtonHighlight = 'button-highlight',
  Chips = 'chips',
}
export default FilterType;
